class ClKlaviyoBackInStock extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
  }

  toggle(show) {
    const overlay = this.shadowRoot.querySelector(".cl-bis-overlay");
    if (overlay) {
      overlay.style.display = show ? "flex" : "none";

      if (show) {
        // Update product info from attributes
        const productData = {
          title: this.getAttribute("product-title") || "",
          image: this.getAttribute("product-image") || "",
          variantTitle: this.getAttribute("variant-title") || "",
        };
        this.updateProductInfo(productData);
      } else {
        // Reset success message when closing
        this.shadowRoot.querySelector(".cl-submit-btn").style.display = "block";
        this.shadowRoot.querySelector(".cl-success-msg").style.display = "none";
      }
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .cl-bis-overlay {
          display: none; position: fixed; top: 0; left: 0;
          width: 100%; height: 100%; background: rgba(0,0,0,0.7);
          z-index: 10000; align-items: center; justify-content: center;
        }
        .cl-bis-modal {
          background: #fff; padding: 0; border-radius: 8px;
          width: 90%; max-width: 515px; position: relative;
        }
        .cl-bis-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 10px 24px; border-bottom: 1px solid #e0e0e0;
          font-family: "EB Garamond";
        }
        .cl-bis-header h2, .cl-bis-message {
          margin: 0; font-size: 24px; font-weight: 400; color: #050027; line-height: 120%; font-family: 'EB Garamond';
        }
        .cl-close-btn {
          cursor: pointer; font-size: 24px; line-height: 1; color: #050027;
          padding: 0; background: none; border: 1px solid transparent;
          width: 32px; height: 32px; border-radius: 4px;
          display: flex; align-items: center; justify-content: center;
          font-weight: 700; transition: all 0.2s ease;
        }
        .cl-close-btn:hover {
          color: #050027; border-color: #050027; background: #fff;
        }
        .cl-bis-content {
          padding: 24px;
        }
        .cl-product-info {
          display: flex; gap: 24px; margin-bottom: 32px; align-items: center;
        }
        .cl-product-image {
          width: 48px; height: 72px; object-fit: cover; border-radius: 4px;
        }
        .cl-product-details {
          flex: 1;
        }
        .cl-product-title {
          font-size: 16px;
          margin: 0 0 8px 0;
          color: #050027;
          line-height: 120%;
          letter-spacing: -0.32px;
        }
        .cl-variant-title p{
          font-size: 14px; color: #050027; margin: 0; font-weight: 500;
          line-height: 120%;
          letter-spacing: -0.28px;
          margin-bottom: 8px;
        }
        .cl-variant-title{
          margin: 0;
        }
        .cl-email-wrapper {
          position: relative; margin: 0 24px 24px;
        }
        input {
          width: 100%; padding: 12px 45px 12px 12px; border: 1px solid #ccc;
          box-sizing: border-box; font-size: 14px; border-radius: 4px;
        }
        .cl-submit-btn {
          position: absolute; right: 5px; top: 50%; transform: translateY(-50%);
          width: 32px; height: 32px; background: #050027; color: #fff;
          border: none; cursor: pointer; border-radius: 4px;
          display: flex; align-items: center; justify-content: center;
        }
        .cl-submit-btn:hover { background: #050027; }
        .cl-submit-btn svg { width: 20px; height: 20px; }
        .cl-success-msg { display: none; margin: 24px; }
      </style>

      <div class="cl-bis-overlay">
        <div class="cl-bis-modal">
          <div class="cl-bis-header">
            <h2>Join waiting list</h2>
            <div class="cl-header__close icon-wrapper cl-close-btn">
              <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.8954 21.3575L12.7109 28.542C12.4979 28.7546 12.2619 28.8546 12.0029 28.842C11.7439 28.829 11.508 28.7161 11.2954 28.5035C11.0827 28.2908 10.9764 28.0485 10.9764 27.7765C10.9764 27.5048 11.0827 27.2625 11.2954 27.0495L18.4414 19.9035L11.2569 12.769C11.0442 12.556 10.9442 12.3136 10.9569 12.042C10.9699 11.7703 11.0827 11.528 11.2954 11.315C11.508 11.1023 11.7504 10.996 12.0224 10.996C12.294 10.996 12.5364 11.1023 12.7494 11.315L19.8954 18.4995L27.0299 11.315C27.2429 11.1023 27.4789 10.996 27.7379 10.996C27.9969 10.996 28.2327 11.1023 28.4454 11.315C28.666 11.5356 28.7764 11.7798 28.7764 12.0475C28.7764 12.3155 28.666 12.556 28.4454 12.769L21.2994 19.9035L28.4839 27.088C28.6965 27.301 28.8029 27.537 28.8029 27.796C28.8029 28.055 28.6965 28.2908 28.4839 28.5035C28.2632 28.7241 28.019 28.8345 27.7514 28.8345C27.4834 28.8345 27.2429 28.7241 27.0299 28.5035L19.8954 21.3575Z" fill="#1C1B1F"/>
              </svg>
            </div>
          </div>
          <div class="cl-bis-content">
            <div class="cl-product-info" style="display: none;">
              <img src="" alt="" class="cl-product-image">
              <div class="cl-product-details">
                <p class="cl-product-title"></p>
                <p class="cl-variant-title"></p>
              </div>
            </div>

            <p class="cl-bis-message">Join waiting list to get notified when this size is back in stock!</p>
          </div>

          <div class="cl-email-wrapper">
            <input type="email" id="cl-bis-email" placeholder="Enter your email">
            <button class="cl-submit-btn" aria-label="Submit">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </button>
          </div>
          <div class="cl-success-msg">
            <p class="cl-bis-message">Thank you, we’ll notify you when this size is back in stock!</p>
          </div>
        </div>
      </div>
    `;

    // 1. Close via the "X" button
    this.shadowRoot.querySelector(".cl-close-btn").onclick = () =>
      this.toggle(false);

    // 2. Close by clicking the dark background (Overlay)
    this.shadowRoot.querySelector(".cl-bis-overlay").onclick = (e) => {
      if (e.target.classList.contains("cl-bis-overlay")) {
        this.toggle(false);
      }
    };

    // 3. Handle Submit
    this.shadowRoot.querySelector(".cl-submit-btn").onclick = () =>
      this.subscribe();
  }

  updateProductInfo(data) {
    const productInfo = this.shadowRoot.querySelector(".cl-product-info");
    const productImage = this.shadowRoot.querySelector(".cl-product-image");
    const productTitle = this.shadowRoot.querySelector(".cl-product-title");
    const variantTitle = this.shadowRoot.querySelector(".cl-variant-title");

    if (data.title) {
      productInfo.style.display = "flex";
      productTitle.textContent = data.title;

      if (data.image) {
        productImage.src = data.image;
        productImage.alt = data.title;
        productImage.style.display = "block";
      } else {
        productImage.style.display = "none";
      }

      if (data.variantTitle && data.variantTitle !== "Default Title") {
        const parts = data.variantTitle.split(" / ");
        const labels = ["Color", "Size"]; // adjust if needed

        // clear previous content
        variantTitle.innerHTML = "";

        parts.forEach((value, index) => {
          const p = document.createElement("p");
          p.textContent = `${labels[index]}: ${value}`;
          variantTitle.appendChild(p);
        });

        variantTitle.style.display = "block";
      } else {
        variantTitle.style.display = "none";
      }
    }
  }

  subscribe() {
    const email = this.shadowRoot.querySelector("#cl-bis-email").value;
    const variantId = this.getAttribute("variant-id");

    if (!email || !variantId) return;

    if (!this.validateEmail(email)) {
      return;
    }

    this.postBackInStock({ email, variantId });

    this.shadowRoot.querySelector(".cl-bis-content").style.display = "none";
    this.shadowRoot.querySelector(".cl-email-wrapper").style.display = "none";
    this.shadowRoot.querySelector(".cl-success-msg").style.display = "block";

    setTimeout(() => {
      this.toggle(false);
      // Reset form for next use
      this.shadowRoot.querySelector(".cl-bis-content").style.display = "block";
      this.shadowRoot.querySelector(".cl-email-wrapper").style.display = "block";
      this.shadowRoot.querySelector(".cl-success-msg").style.display = "none";
    }, 1800);
  }

  postBackInStock(data) {
    const baseUrl =
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=M2zGdW";

    const payload = this.preparePayload(data.email, data.variantId);
    const options = {
      method: "POST",
      headers: {
        revision: "2026-01-15",
        accept: "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify(payload),
    };

    fetch(baseUrl, options)
      .then(() => this.upsertProfileCountry(data.email))
      .catch((err) => console.error(err));
  }

  upsertProfileCountry(email) {
    const storeCountry = window.themeVariables?.settings?.storeCountry;
    console.log("DEBUG store country", storeCountry);
    if (!storeCountry) return;

    fetch("https://a.klaviyo.com/client/profiles/?company_id=M2zGdW", {
      method: "POST",
      headers: {
        revision: "2026-01-15",
        accept: "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify({
        data: {
          type: "profile",
          attributes: {
            email,
            properties: { store_country: storeCountry },
          },
        },
      }),
    }).catch((err) => console.error(err));
  }

  preparePayload(email, variantId) {
    return {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: { type: "profile", attributes: { email: email } },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };
  }

  validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }
}

customElements.define("cl-klaviyo-bis-popup", ClKlaviyoBackInStock);
